<div class="container">
  <div class="modal-header">
    <h1 class="header">{{title}}</h1>
    <ion-button fill="clear" class="close-btn" (click)="closeModal()">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </div>

  <div  class="ack-title" *ngIf = "isAcknowledgmentRequired&&!isVideo&&!isCustom">
    Please read and acknowledge this document before applying to the shift.
  </div>
  <div class="ack-title" *ngIf = "isAcknowledgmentRequired&&isVideo">
    Please watch and acknowledge this video before applying to the shift.
  </div>
  <div class="ack-title" *ngIf = "isAcknowledgmentRequired&&isCustom">
    Please read and acknowledge this bulletin before applying to the shift.
  </div>

  <div *ngIf="!isTemplate && !isCustom" class="acknowledgment-content">
    <app-video-player class="video-container" *ngIf = "isVideo" [url]="url" ></app-video-player>
    <app-pdf-viewer *ngIf = "!isVideo" [url]="url"></app-pdf-viewer>
  </div>

  <div *ngIf="isTemplate" class="acknowledgment-content">
      <object class="doc-container" [data]="url | embedDOCFile">
          <embed [src]="url | embedDOCFile" />
      </object>
  </div>

  <div *ngIf="isCustom" class="acknowledgment-content custom-content">
    <div class="rich-text-content" [innerHTML]="description | sanitizeHtml"></div>
  </div>

  <div  *ngIf="isAcknowledgmentRequired" class="acknowledgment-txt">
    <div class="bulletin-checkbox">
      <input type="checkbox" [(ngModel)]="acknowedgment" class="custom-checkbox" value=true>
    </div>
    <div class="ack-disclaimer" *ngIf = "!isVideo&&!isCustom">
      I acknowledge that I have read and understand this document
    </div>
    <div class="ack-disclaimer" *ngIf = "isVideo">
      I acknowledge that I have watched and understood this video.
    </div>
    <div class="ack-disclaimer" *ngIf = "isCustom">
      I acknowledge that I have read and understand this bulletin
    </div>
  </div>
  <div *ngIf="isAcknowledgmentRequired" class="buttons-section">
    <ion-button [disabled]="!acknowedgment" color="basic" id="success-popup-btn" class=" ion-no-margin btn success-popup-ok"
      (click)='acknowledgeDocument()'>
      Complete
    </ion-button>
  </div>
</div>